import { AdaptiveDesignSystem, buttonAestheticStyles, anchorStyleModules, buttonTemplateStyles, composeButton } from "@adaptive-web/adaptive-web-components";
import { css } from "@microsoft/fast-element";
import { MatchMediaStyleSheetBehavior } from "@microsoft/fast-foundation";
import { darkModeQuery } from "../../style.js";
import { focusStrokeOuter, focusStrokeThickness } from '@adaptive-web/adaptive-ui/reference';

export const customButtonDefinition = composeButton(AdaptiveDesignSystem, {
  styleModules: anchorStyleModules,
  styles: [
    buttonTemplateStyles,
    buttonAestheticStyles,
    css`
      .control {
        border: none !important;
        background-color: var(--primary-color) !important;
        color: var(--on-primary-color) !important;
      }

      [part=content] {
        font-family: var(--body-font-family);
        font-variation-settings: 'wght' 600;
      }

      :host([appearance="accent"]) .control {
        background-color: var(--secondary-color) !important;
        color: var(--on-secondary-color) !important;
      }
      
      ::slotted([slot=start]) {
        color: var(--secondary-color);
      }

      :host([appearance="accent"]:hover) .control {
        box-shadow: inset 0 0 0 2px var(--secondary-color), inset 0 0 0 4px currentcolor;
      }

      :host([appearance="lightweight"]:hover) .control,
      :host(:not([appearance]):hover) .control {
        box-shadow: inset 0 0 0 2px var(--primary-color), inset 0 0 0 4px var(--secondary-color);
      }

      .control:focus-visible {
        outline: ${focusStrokeThickness} solid ${focusStrokeOuter};
        outline-offset: 1px;
      }
    `.withBehaviors(
      new MatchMediaStyleSheetBehavior(
        darkModeQuery,
        css`
          ::slotted([slot=start]) {
            color: var(--primary-color);
          }
        `
      )
    )
  ]
})